import { render, staticRenderFns } from "./ManagePhoto.vue?vue&type=template&id=ed20f32a&scoped=true&"
import script from "./ManagePhoto.vue?vue&type=script&lang=js&"
export * from "./ManagePhoto.vue?vue&type=script&lang=js&"
import style0 from "./ManagePhoto.vue?vue&type=style&index=0&id=ed20f32a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed20f32a",
  null
  
)

export default component.exports